<template>
  <div>
    <!-- 教培数据统计三个导出共用：筛选条与报表页一致，导出按钮触发后端异步任务 -->
    <filter-bar ref="filter" :mode="mode" :scope="scope"
                :show-customer="showCustomer"
                :show-portrait="code === 'EEForEduCustomerStats'"
                :show-big="showBig" :export-code="code" @export="handleDownload" />
  </div>
</template>

<script>
import eduStatsApi from '@/api/count/eduStats'
import filterBar from '@/views/count/eduStats/filterBar.vue'

const CONFIG = {
  EEForEduTeacherStats: { mode: 'range', showCustomer: false, showBig: false, api: 'exportTeacher' },
  EEForEduCustomerStats: { mode: 'range', showCustomer: true, showBig: true, api: 'exportCustomer' },
  EEForEduNewCustomerStats: { mode: 'year', showCustomer: true, showBig: false, api: 'exportNewCustomer' }
}

export default {
  components: { filterBar },
  props: ['code'],
  data() {
    return { scope: { restricted: false } }
  },
  computed: {
    conf() { return CONFIG[this.code] || CONFIG.EEForEduTeacherStats },
    mode() { return this.conf.mode },
    showCustomer() { return this.conf.showCustomer },
    showBig() { return this.conf.showBig }
  },
  created() {
    eduStatsApi.getScope().then(({ data }) => { this.scope = data || { restricted: false } })
  },
  methods: {
    handleDownload() {
      const query = this.$refs.filter.buildQuery()
      return this.$common.confirm('是否确认导出')
        .then(() => eduStatsApi[this.conf.api](query))
        .then(res => {
          if (res.code === '0') {
            setTimeout(() => this.$emit('created'), 500)
          }
        })
    }
  }
}
</script>
